<template>
  <div class="section-main__warp" style="margin-top: 0px;">
    <div class="fuel-related">
      <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
        @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        <template slot="menuLeft">
          <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
        </template>
      </ioc-table>
      <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
        width="35%">
        <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
          <el-form-item label="类型" prop="siteType">
            <el-select v-model="addForm.siteType" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in siteTypeArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场地名称" prop="siteName">
            <el-input v-model="addForm.siteName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="场地面积" prop="siteArea">
            <el-input v-model="addForm.siteArea" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳汇系数" prop="sinkCoefficient">
            <el-input v-model="addForm.sinkCoefficient" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳减排量" prop="co2Reduction">
            <el-input v-model="addForm.co2Reduction" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="siteRemark">
            <el-input v-model="addForm.siteRemark" placeholder="请输入" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
          <el-button @click="addCancel('addForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/grasslands";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        siteType: [{ required: true, message: '请选择类型', trigger: ['blur', 'change'] }],
        siteName: [{ required: true, message: '请输入场地名称', trigger: ['blur', 'change'] }],
        siteArea: [{ required: true, message: '请输入场地面积', trigger: ['blur', 'change'] }],
        sinkCoefficient: [{ required: true, message: '请输入碳汇系数', trigger: ['blur', 'change'] }],
        co2Reduction: [{ required: true, message: '请输入碳减排量', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        siteId: null,
        siteType: '',
        siteName: '',
        siteArea: '',
        sinkCoefficient: '',
        co2Reduction: '',
        siteRemark: ''
      },
      siteTypeArr: [{ 'label': '草地', 'value': '0' }, { 'label': '湿地', 'value': '1' }]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        siteType: this.searchForm.siteType
      };
      this.$fetch(api.grasslands.querySiteList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.addForm.siteId = ''
      this.addForm.siteType = ''
      this.addForm.siteName = ''
      this.addForm.siteArea = ''
      this.addForm.sinkCoefficient = ''
      this.addForm.co2Reduction = ''
      this.addForm.siteRemark = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.siteId) {
            let params = {
              siteId: this.addForm.siteId,
              siteType: this.addForm.siteType,
              siteName: this.addForm.siteName,
              siteArea: this.addForm.siteArea,
              sinkCoefficient: this.addForm.sinkCoefficient,
              co2Reduction: this.addForm.co2Reduction,
              siteRemark: this.addForm.siteRemark,
            }
            this.$fetch(api.grasslands.updateSiteList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              siteType: this.addForm.siteType,
              siteName: this.addForm.siteName,
              siteArea: this.addForm.siteArea,
              sinkCoefficient: this.addForm.sinkCoefficient,
              co2Reduction: this.addForm.co2Reduction,
              siteRemark: this.addForm.siteRemark,
            }
            this.$fetch(api.grasslands.addSiteList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改'
      this.addForm.siteId = row.siteId
      this.addForm.siteType = row.siteType
      this.addForm.siteName = row.siteName
      this.addForm.siteArea = row.siteArea
      this.addForm.sinkCoefficient = row.sinkCoefficient
      this.addForm.co2Reduction = row.co2Reduction
      this.addForm.siteRemark = row.siteRemark
      this.addVisible = true;
    },
    // 删除
    handleDel(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/carbon/reduction/site/del/' + row.siteId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fuel-related {
  width: 100%;
  height: calc(100vh - 115px);
}
</style>